import React from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";

const BCSelectFieldOpt = (props) => {
    const { controlId, label, size, children, ...rest } = props;
    const [field, meta] = useField(props);

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                {...rest}
                {...field}
                as="select"
                isInvalid={meta.error && meta.touched}
                isValid={!meta.error && meta.touched}
                size={size}
            >
                {children}
            </Form.Control>
            {meta.error && meta.touched ? (
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            ) : null}
        </Form.Group>
    );
};

BCSelectFieldOpt.defaultProps = {
    size: "md"
};

export default BCSelectFieldOpt;
